import { render } from "./SiteView.vue?vue&type=template&id=70843a80"
import script from "./SiteView.vue?vue&type=script&lang=js"
export * from "./SiteView.vue?vue&type=script&lang=js"

import "./SiteView.vue?vue&type=style&index=0&id=70843a80&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__